import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3.332 2C2.605 2 2 2.605 2 3.332v9.336C2 13.395 2.605 14 3.332 14h9.336c.727 0 1.332-.605 1.332-1.332V3.332C14 2.605 13.395 2 12.668 2Zm0 1.332h9.336v9.336H3.332Zm0 0",
  style: {"stroke":"none","fill-rule":"nonzero","fill":"#000","fill-opacity":"1"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }